<template>
  <div>
    <div class="header">
      <div class="title">
        <img src="/static/images/icons/notification_blue.svg" class="notification_icon" />
        <span>Notifications</span>
      </div>
    </div>
    <div class="content" :class="{ 'single-height': !isCombo }">
      <div
        class="each-notification"
        v-for="(notificationsPerDate, index) in notificationsList"
        v-bind:key="index"
      >
        <div class="row ml0">
          <div class="col-xs-12 notification-date-css">
            {{ notificationsPerDate.date | formatDate('YYYY-MM-DD', 'MMM DD, YYYY') }}
          </div>
        </div>
        <div
          class="row ml0 mt-12"
          v-for="(notification, index) in notificationsPerDate.notifications"
          v-bind:key="index"
        >
          <div class="col-xs-1">
            <span
              class="flag-icon flag-icon-squared"
              :class="notification.icon"
              v-if="notification.type == 'RW' || notification.type == 'UN'"
            ></span>
            <!-- Reg Tracker OR Reg Watch -->
            <img
              v-else-if="notification.type == 'SB'"
              src="/static/images/icons/track_plus_icon_blue.svg"
              alt="track-plus-icon"
            />
            <!-- SB-->
            <img
              v-else-if="notification.type == 'PC'"
              src="/static/images/icons/prod_classification_blue.svg"
              alt="prodclassification-icon"
            />
            <!-- PC-->
            <img
              v-else-if="notification.type == 'RP'"
              src="/static/images/icons/reg_pathway_blue.svg"
              alt="regpathway-icon"
            />
            <!-- RP-->
            <img
              v-else
              src="/static/images/icons/smartexchange_icon_blue.svg"
              alt="smartexchange-icon"
            />
            <!-- SX-->
          </div>
          <div class="col-xs-10 notification-details word-wrap">
            <span v-if="notification.type == 'RW'"
              >New Regulatory update has been published for {{ notification.country_name }}</span
            >
            <!-- Reg watch-->
            <span
              v-else-if="
                notification.type == 'UN' ||
                notification.type == 'SX' ||
                notification.type == 'PC' ||
                notification.type == 'RP'
              "
              >{{ notification.title }}</span
            >
            <!-- Reg Tracker OR SX OR PC OR RP -->
            <span v-else>
              <!--notification type SB-->
              <span v-if="notification.notification_type == 'Project'">
                <span v-if="notification.project_action_type == 'Export'"
                  >{{ notification.project_title }}
                  <span v-if="notification.project_status == 'Success'">has been exported </span>
                  <span v-if="notification.project_status == 'Fail'">export failed</span>
                </span>
                <span v-if="notification.project_action_type == 'Complete'"
                  >The {{ notification.project_title }}
                  <span v-if="notification.project_status == 'Success'">is 100% complete</span>
                  <span v-if="notification.project_status == 'Fail'">is not completed</span>
                </span>
              </span>
              <span v-if="notification.notification_type == 'User Comment'">
                <span v-if="notification.comment_type == 'Commented'"
                  >You have been mentioned in {{ notification.project_title }}</span
                >
                <!-- comment_type is Replied -->
                <span v-if="notification.comment_type == 'Replied'"
                  >{{ notification.commentator_name }} have been mentioned in
                  {{ notification.project_title }}</span
                >
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import EventBus from '../../../../utils/event-bus';
import { getNotifications } from '../../../../apis/notification';

export default {
  props: ['isCombo'],
  data() {
    return {
      notificationsList: [],
      notificationscount: 2,
      loaderStatus: false
    };
  },
  methods: {
    redirect(url) {
      this.$router.push(url);
      EventBus.$emit('activeMenuTitle', this.$route.meta.title);
    },
    /* getNotificationSummary method to get the latest 4 notifications */
    async getNotificationSummary() {
      this.notificationsList = [];
      const notifications = await getNotifications(this.notificationscount);
      if (notifications.length > 0) {
        const notificationdates = [];
        notifications.forEach((notification) => {
          if (notificationdates.indexOf(notification.creation_date) === -1) {
            notificationdates.push(notification.creation_date);
          }
        });
        this.notificationsList = notificationdates.map((date) => {
          const notificationsPerDate = {
            date,
            notifications: notifications.filter((eachNotification) => {
              Object.assign(eachNotification, {
                icon: eachNotification.country_code
                  ? `flag-icon-${eachNotification.country_code.toLowerCase()}`
                  : ''
              });
              return eachNotification.creation_date === date;
            })
          };
          return notificationsPerDate;
        });
      }
    }
  },
  filters: {
    formatDate(date, exisitngformat, format) {
      return date ? moment(date, exisitngformat).format(format) : '';
    }
  },
  async created() {
    try {
      this.loaderStatus = true;
      await this.getNotificationSummary();
      this.loaderStatus = false;
    } catch (err) {
      this.loaderStatus = false;
    }
  }
};
</script>
<style scoped>
.header {
  border: 1px solid #ffffff;
  border-radius: 10px 10px 0px 0px;
}
.title {
  display: flex;
  align-items: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0b3c61;
  padding-left: 24px;
  padding-top: 24px;
}
.title span {
  padding-left: 19px;
}
.notification_icon {
  width: 32px;
  height: 32px;
  margin-top: -3px;
}
.ml0 {
  margin-left: 0px;
}
.content {
  padding: 5px 15px 10px 10px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}
.fix-height {
  height: 230px;
}
.single-height {
  max-height: 175px;
}
.mr-10 {
  margin-right: 10px;
}
.date-css {
  font-weight: 500;
  font-size: 16px;
  color: #174c76;
  padding-right: 0px;
  text-align: left;
}
.notification-date-css {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}
.content-decoration {
  position: relative;
  padding: 0;
  border-top: 1px solid #174c76;
}
.mt-10 {
  margin-top: 10px;
}
.headline-circle {
  position: absolute;
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background: #174c76;
  padding: 0;
  right: 0;
  top: -3px;
}
.mt-5 {
  margin-top: 5px;
}
.mt-12 {
  margin-top: 12px;
}
.flag-icon {
  font-size: 20px;
}
.notification-details {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 17px;
}
.word-wrap {
  word-wrap: break-word;
}
.each-notification img {
  width: 20px;
  height: 20px;
}
.each-notification:last-child {
  margin-top: 14px;
}
@media only screen and (max-width: 767px) {
  .single-height {
    max-height: 220px;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .upcoming-widget {
    margin-top: 20px;
  }
}
</style>
